import React, { PropsWithChildren } from "react";
import styles from "./maskScroller.module.scss";

interface MaskScrollerProps extends PropsWithChildren {
    internalMargin?: string;
}

const MaskScroller = ({ internalMargin, children }: MaskScrollerProps) => {
    const styleProps = {
        "--internalMargin": internalMargin,
    } as React.CSSProperties;

    return (
        <div className={styles.maskScrollerOuter} style={styleProps}>
            <div className={styles.maskScrollerInner}>{children}</div>
        </div>
    );
};

export default MaskScroller;
